import { Token, TokenValue } from "../domain/token";
import { TokenRepository } from "../domain/tokenRepository";
import { client } from "../../../api/client";

export function createApiTokenRepository(): TokenRepository {
  return {
    copy,
    get,
    getOrCreate,
  };
}

async function copy(token: string) {
  navigator.clipboard.writeText(token);
}

async function get() {
  const token = await client.get(`get_user_token/`).then(
    (response) => response.data as Promise<Token>
  );
  return token;
}

async function getOrCreate() {
  const resp=await client.post(`activate_link/`);
  const token = new TokenValue(resp.data.key)
  return token;
}

